export const HEADER_TABS = 'header_tabs';
